import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from '~/app/core/services';

@Component({
  selector: 'app-additional-files-view',
  templateUrl: './additional-files-view.component.html',
  styleUrls: ['./additional-files-view.component.scss']
})
export class AdditionalFilesViewComponent implements OnInit {
  @Input() additionalFiles: any[];
  @Input() class: any;
  constructor(
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
  }

  viewFile(doc) {
    this.commonService.processFile(doc.s3_key);
  }
}
